<!-- #28 -->
<template>
  <v-col>
    <v-data-table
      v-model="selectedGroups"
      :headers="headers"
      :items="groups"
      :search="search"
      :loading="groupsLoader"
      class="elevation-1"
      item-key="id"
      show-select
      disable-pagination
      :options.sync="options"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>User Groups</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2 mr-2" @click="addGroup(0)">
            Create Group
          </v-btn>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in allGroupStatuses"
                :key="i"
                @click="openConfirm(item)"
              >
                <v-list-item-title
                  >{{ item.text }} Selected Groups</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-divider class="mt-1 mb-4"></v-divider>
        <v-form>
          <v-row class="custom-row pl-5 pr-5 mb-1">
            <v-col cols="12" sm="3">
              <v-text-field label="Name" v-model="name" outlined></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="screen"
                hide-no-data
                outlined
                label="Screen"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="status"
                label="Status"
                item-text="text"
                item-value="value"
                :items="statuses"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="user_category"
                label="User Category"
                item-text="value"
                item-value="id"
                :items="userTypes"
                outlined
                @change="fetchGroups()"
              ></v-select>
            </v-col>
            <v-col v-if="user_category === 1" cols="12" sm="3">
              <v-autocomplete
                v-model="client_id"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                outlined
                label="Select client"
                placeholder="Start typing to Search"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 2">
              <v-autocomplete
                v-model="seller_id"
                :items="sellers"
                :loading="sellerLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Seller"
                placeholder="Start typing to Search"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              :class="[
                user_category === 1 || user_category == 2
                  ? 'offset-md-6'
                  : 'offset-md-9',
              ]"
            >
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-5"
                @click="searchAll"
                style="float: right"
                >Search</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>
      <template v-slot:item.active="{ item }">
        <v-chip class="ma-1" :color="item.active ? 'success' : 'error'">
          {{ item.active ? "Active" : "Inactive" }}
        </v-chip>
      </template>
      <template v-slot:item.screens="{ item }">
        <v-chip class="ma-1" v-for="s in item.screens" :key="s.id"
          >{{ s.screen_id }} {{ s.name }}</v-chip
        >
      </template>
      <template v-slot:[`item.user_category_name`]="{ item }">
        {{ category(item.user_category_name, item) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small @click="addGroup(item.id)"> mdi-pencil </v-icon>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to ' + action.text + ' selected groups?'"
      :loader="statusLoader"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
  </v-col>
</template>
<script>
import { groupStatuses } from "@/config/data";
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapGetters(["userTypes"]),
    allGroupStatuses() {
      delete groupStatuses.delete;
      return Object.keys(groupStatuses).map((i) => {
        return {
          text: groupStatuses[i],
          value: i,
        };
      });
    },
  },
  data: () => ({
    sellers: [],
    clients: [],
    user_category: null,
    dialogConfirm: false,
    statusLoader: false,
    searchType: "",
    statuses: [
      {
        text: "Active",
        value: "True",
      },
      {
        text: "InActive",
        value: "False",
      },
    ],
    items: [
      { id: 1, text: "Client", value: 1 },
      { id: 2, text: "Seller", value: 2 },
      { id: 3, text: "RSA", value: 3 },
      { id: 4, text: "PAS", value: 4 },
    ],
    searchOptions: [
      {
        text: "Group Name",
        value: "",
      },
      {
        text: "Category",
        value: "user_category",
      },
      {
        text: "Screen",
        value: "screen",
      },
    ],
    headers: [
      {
        text: "Group Name",
        value: "name",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Number of Users",
        value: "no_of_users",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Group Status",
        value: "active",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Screen Access",
        value: "screens",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "User Category",
        value: "user_category_name",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    groups: [],
    selectedGroups: [],
    groupsLoader: false,
    action: {},
    search: null,
    _timerId: null,
    client_id: null,
    seller_id: null,
    name: null,
    screen: [],
    screens: [],
    screenloader: false,
  }),

  created() {
    this.fetchMemberGroups();
    this.getUserTypes();
  },
  watch: {
    options: {
      handler() {
        this.fetchMemberGroups();
      },
      deep: true,
    },
    search() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        if (this.search) this.fetchMemberGroups();
      }, 300);
    },
    searchType() {
      if (this.search) this.fetchMemberGroups();
    },
  },
  methods: {
    ...mapActions([
      "getMemberGroups",
      "createMemberGroup",
      "updateMemberGroup",
      "deleteMemberGroup",
      "changeMemberGroupStatus",
      "snackBar",
      "getUserTypes",
      "fetchClient",
      "getSellersActiveList",
    ]),
    fetchMemberGroups() {
      this.groups = [];
      this.groupsLoader = true;
      this.getMemberGroups({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.groupsLoader = false;
          this.groups = res.data;
        })
        .catch(() => {
          this.groupsLoader = false;
        });
    },

    addGroup(id) {
      this.$router.push({
        name: "GroupCreate",
        params: {
          id: id,
        },
      });
    },
    clearAll() {
      this.name = null;
      this.group = null;
      this.user_category = null;
      this.client_id = null;
      this.seller_id = null;
      this.filtersArr = [];
      this.status = null;
      this.screen = null;

      this.fetchMemberGroups();
    },
    allFilters() {
      this.orderLoader = true;
      if (this.user_category == 3) {
        this.client_id = null;
        this.seller_id = null;
      }
      let obj = {
        group_name: this.name,
        screens: this.screen,
        user_category: this.user_category,
        clientid: this.client_id,
        sellerid: this.seller_id,
        active: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.fetchMemberGroups();
    },
    fetchClientList() {
      if (this.clients.length > 0) return;
      this.clientLoader = true;
      this.fetchClient({
        fields: "id,name",
        pagination: 0,
        active: this.user_category,
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    fetchSellerList() {
      if (this.sellers.length > 0) return;
      this.sellerLoader = true;
      this.getSellersActiveList({
        // client_id: this.userData.client_id,
        params: {
          fields: "id,name",
          pagination: 0,
          // active: this.userData.user_category,
        },
      })
        .then((res) => {
          this.sellerLoader = false;
          this.sellers = res.data;
        })
        .catch(() => {
          this.sellerLoader = false;
        });
    },
    fetchGroups() {
      if (this.user_category == 1) {
        this.fetchClientList();
      } else if (this.user_category == 2) {
        this.fetchSellerList();
      }
    },
    openConfirm(action) {
      if (this.selectedGroups.length === 0) {
        return this.snackBar({
          color: "error",
          message: "Please select atleast one group",
        });
      }
      this.action = action;
      this.dialogConfirm = true;
    },

    closeConfirm() {
      this.dialogConfirm = false;
    },

    confirmAction() {
      this.statusLoader = true;
      this.changeMemberGroupStatus({
        action: this.action.value,
        data: { group_ids: this.selectedGroups.map((i) => i.id) },
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.selectedGroups = [];
          this.fetchMemberGroups();
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },
    category(type, item) {
      if (type == "Seller") {
        if (item.seller_name !== null && item.seller_name !== "") {
          return `Seller (${item.seller_name})`;
        } else {
          return type;
        }
      } else if (type == "Client") {
        if (item.client_name !== null && item.client_name !== "") {
          return `Client (${item.client_name})`;
        } else {
          return type;
        }
      } else {
        return type;
      }
    },
  },
};
</script>
